import React from 'react';
import { Link } from 'react-router-dom';
import aboutus from '../../../images/Icons/aboutus.svg';
import goal from '../../../images/Icons/goal.svg';
import mediakit from '../../../images/Icons/mediakit.svg';

const Resources = () => {
  return (
    <div className="greyframe">
      <div className="resourcesContainer container">
        <div className="newsTitle" style={{ marginBottom: 0 }}>
          <div style={{ fontSize: 32, fontWeight: 700 }}>Resources</div>
        </div>
        <div className="allResources">
          <Link
            to="/aboutus"
            style={{ textDecoration: 'none', color: '#414141' }}>
            <div className="resourceBox">
              <div className="singleResourceTitle">
                <img src={aboutus} style={{ marginRight: 9 }}></img>About
                Autzu
              </div>
              <div>
                Explore our mission to create a greener future through
                sustainable urban mobility innovations.
              </div>
            </div>
          </Link>
          <Link
            to="/goal"
            style={{ textDecoration: 'none', color: '#414141' }}>
            {' '}
            <div className="resourceBox">
              <div className="singleResourceTitle">
                <img src={goal} style={{ marginRight: 9 }}></img>
                Goals & Vision
              </div>
              <div>
                Unveil Autzu's strategic objectives for global expansion
                and a sustainable transportation future.
              </div>
            </div>
          </Link>
          <Link
            to="/mediakit"
            style={{ textDecoration: 'none', color: '#414141' }}>
            {' '}
            <div className="resourceBox">
              <div className="singleResourceTitle">
                <img src={mediakit} style={{ marginRight: 9 }}></img>
                Media kit
              </div>
              <div>
                Find resources highlighting Autzu's impact, including press
                releases, images, and updates.
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Resources;



// WEBPACK FOOTER //
// ./src/components/Newsroom/Resources/index.js